export default function isTrackingAllowed () {
  if (!window.cookieyes || !window.cookieyes.consent) {
    console.warn('CookieYes ei ole saadaval või kasutaja ei ole nõustunud küpsistega.');
    return false;
  }

  const consent = window.cookieyes.consent;
  return consent.advertisement || consent.analytics;
}
